/**
 * Styles pour la zone des messages
 * Design moderne inspiré de la landing page avec des bordures moins arrondies
 */
export const MESSAGES_STYLES = `
  /* Messages area */
  .ringado-messages {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #fafafa;
    min-height: 0; /* Important for flex child scroll */
    scrollbar-width: thin;
    scrollbar-color: #d1d5db #f9fafb;
    scroll-behavior: smooth;
  }

  .ringado-messages::-webkit-scrollbar {
    width: 4px;
  }

  .ringado-messages::-webkit-scrollbar-track {
    background: transparent;
  }

  .ringado-messages::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 2px;
  }

  .ringado-messages::-webkit-scrollbar-thumb:hover {
    background: #9ca3af;
  }

  .ringado-message {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
  }

  .ringado-message.user {
    justify-content: flex-end;
  }

  .ringado-avatar {
    width: 28px;
    height: 28px;
    border-radius: 6px; /* Moins arrondi */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
    overflow: hidden;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .ringado-avatar.connected {
    background: #3b82f6;
  }

  .ringado-avatar.assistant {
    background: #111827;
  }

  .ringado-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .ringado-avatar .icon {
    color: white;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ringado-avatar svg {
    width: 14px;
    height: 14px;
    fill: currentColor;
  }

  .ringado-message-bubble {
    border-radius: 8px; /* Moins arrondi, style plus moderne */
    padding: 10px 14px;
    max-width: 260px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: none;
    /* Style plus épuré */
  }

  .ringado-message.user .ringado-message-bubble {
    background: #111827;
    color: white;
    border-bottom-right-radius: 3px;
    /* Petit détail d'arrondi différent pour indiquer l'utilisateur */
  }

  .ringado-message.assistant .ringado-message-bubble {
    background: #f3f4f6;
    color: #374151;
    border-bottom-left-radius: 3px;
    border: 1px solid rgba(229, 231, 235, 0.6);
  }

  .ringado-message.operator .ringado-message-bubble {
    background: #eff6ff;
    color: #1e40af;
    border-bottom-left-radius: 3px;
    border: 1px solid rgba(59, 130, 246, 0.1);
  }

  /* Typing indicator */
  .ringado-typing {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 6px;
  }

  .ringado-typing .ringado-message-bubble {
    background: #f3f4f6;
    border: 1px solid rgba(229, 231, 235, 0.6);
    display: flex;
    gap: 4px;
    align-items: center;
    padding: 12px 14px;
    min-height: 20px;
  }

  .ringado-typing-dot {
    width: 5px;
    height: 4px;
    background: #6b7280;
    border-radius: 50%;
    animation: ringado-typing 1.4s ease-in-out infinite;
  }

  .ringado-typing-dot:nth-child(2) {
    animation-delay: 0.2s;
  }

  .ringado-typing-dot:nth-child(3) {
    animation-delay: 0.4s;
  }

  /* Responsive adjustments */
  @media (max-width: 480px) {
    .ringado-messages {
      padding: 12px;
      gap: 10px;
    }

    .ringado-message-bubble {
      max-width: 200px;
      font-size: 13px;
      padding: 7px 10px;
    }

    .ringado-avatar {
      width: 20px;
      height: 20px;
    }

    .ringado-avatar svg {
      width: 10px;
      height: 10px;
    }
  }

  /* Animation pour l'indicateur de frappe */
  @keyframes ringado-typing {
    0%, 80%, 100% {
      transform: scale(0);
      opacity: 0.5;
    }
    40% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;
